exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  width: 610px;\n  overflow: hidden; }\n  :host .panels {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 200%; }\n    :host .panels .panel {\n      width: 610px;\n      transition: 0.2s ease;\n      background: #FAFBFB; }\n    :host .panels.response .panel {\n      -webkit-transform: translate(-100%);\n              transform: translate(-100%); }\n  :host circular-loader {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    height: 100%;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center; }\n\n@media (max-width: 1000px) {\n  :host {\n    width: 100vw !important; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/patient/patient.component.scss
// module id = 480
// module chunks = 1